export default __webpack_public_path__ + "static/media/circle-filled-orange.b0bbd77a.svg";